import { IonContent, IonPage } from '@ionic/react';
import React, { useEffect, useState } from 'react';

import Padding from '@/components/common/padding/Padding';
import Spacer from '@/components/common/spacer/Spacer';
import BackgroundShapes from '@/components/landingPage/backgroundShapes/BackgroundShapes';
import Faqs from '@/components/landingPage/faqs/Faqs';
import Footer from '@/components/landingPage/footer/Footer';
import Hero from '@/components/landingPage/hero/Hero';
import HowItWorks from '@/components/landingPage/howItWorks/HowItWorks';
import Logo from '@/components/landingPage/logo/Logo';
import Metrics from '@/components/landingPage/metrics/Metrics';
import Pricing from '@/components/landingPage/pricing/Pricing';
import Testimonials from '@/components/landingPage/testimonials/Testimonials';
import TrustedBy from '@/components/landingPage/trustedBy/TrustedBy';

import './LandingPage.css';

const LandingPage: React.FC = () => {
  const [anchor, setAnchor] = useState<string>('');

  useEffect(() => {
    setAnchor(window.location.hash);

    const onHashChange = () => {
      setAnchor(window.location.hash);
    };

    window.addEventListener('hashchange', onHashChange);

    return () => {
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);

  useEffect(() => {
    if (anchor) {
      const anchorElement = document.getElementById(anchor.slice(1));
      if (anchorElement) {
        setTimeout(() => {
          anchorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 742);
      }
    }
  }, [anchor]);

  return (
    <IonPage id="landingPage">
      <IonContent>
        <BackgroundShapes />
        <Padding customMaxWidth={624}>
          <Logo fixed={!!anchor} />
          <Hero />
          <Spacer top={98} />
          <TrustedBy />
          <HowItWorks />
          <Metrics />
          <Testimonials />
          <Pricing />
          <Faqs />
          <Footer />
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default LandingPage;
